/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) {
  $($('.product-single__box__block--description').find('h6').get().reverse()).each(function(i) {
    var tabName = $(this).text();
    tabContent = '';
    //check if h6 has text inside
    if ($(this).text() != '') {
      //hide h6
      $(this).hide();
      //combine content between H6 elements
      $(this).nextUntil('h6').each(function() {
        tabContent = tabContent + this.outerHTML;
        //hide content
        $(this).hide();
      });
      //generate tab HTML
      $('.product-single__accordion.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
      $('.product-single__accordion.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><div class="product-single__accordion__title-wrapper"><h3 class="product-single__accordion__title-text u-large f-family--body">' + tabName + '</h3><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></div></a>');
    } else {
      //hide empty H6
      $(this).hide();
    }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
        .removeClass(activeClass)
        .stop()
        .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
        .addClass(activeClass)
        .stop()
        .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});

/*-----------------------------------------------------------------------------/
/ Fatture Italia - Fix: Allow invoice modal to receive focus over MFP
/ Magnific Popup uses jQuery focusin.mfp to trap focus inside .mfp-wrap.
/ This patch overrides that handler to also allow focus on invoice-modal.
/-----------------------------------------------------------------------------*/
(function() {
  function patchMfpFocusTrap() {
    if (typeof jQuery === 'undefined' || !jQuery.magnificPopup) return;
    var mfp = jQuery.magnificPopup.instance;
    var origFocusIn = mfp._onFocusIn;
    mfp._onFocusIn = function(e) {
      var target = e.target;
      // Allow focus inside invoice-modal (Fatture Italia)
      if (target && target.closest && target.closest('invoice-modal')) {
        return;
      }
      return origFocusIn.call(this, e);
    };
    // Re-bind the patched handler to jQuery's event system
    jQuery(document).off('focusin.mfp');
    jQuery(document).on('focusin.mfp', jQuery.proxy(mfp._onFocusIn, mfp));
  }
  // Patch on DOMContentLoaded and also after a small delay for late-loading MFP
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(patchMfpFocusTrap, 500);
    });
  } else {
    setTimeout(patchMfpFocusTrap, 500);
  }
})();

/*-----------------------------------------------------------------------------/
/ GCB - Fix menu ABBONAMENTI/SUBSCRIPTIONS: il click sul link genitore del menu
/ desktop naviga alla collezione abbonamenti (il toggle della tendina del tema
/ non si apre in modo affidabile al click). Scoped SOLO a quel link.
/-----------------------------------------------------------------------------*/
(function() {
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('.primary-nav__item a[href*="solo-abbonamenti"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    window.location.href = href;
  }, true);
})();
